import styled from 'styled-components';

export const CheckUsernameButton = styled.button`
  display: flex;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: center;
`;